import request from '@/utils/request'

let Enterprise_settlement_reviewApi = {

  /*企业入驻审核列表*/
  list(data) {
    return request._post('/shop/plus.enterprise_settlement_review.Index/index', data);
},
/*添加企业入驻审核*/
add(data) {
    return request._post('/shop/plus.enterprise_settlement_review.Index/add', data);
},
/*修改企业入驻审核*/
edit(data) {
    return request._post('/shop/plus.enterprise_settlement_review.Index/edit', data);
},
/*删除企业入驻审核*/
del(data) {
    return request._post('/shop/plus.enterprise_settlement_review.Index/del', data);
},
/*企业入驻审核详情*/
detail(data) {
  return request._post('/shop/plus.enterprise_settlement_review.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.enterprise_settlement_review.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.enterprise_settlement_review.Setting/getSetting', data, errorback);
    },
    passCanel(data, errorback) {
        return request._post('/shop/plus.enterprise_settlement_review.Index/passCanel', data, errorback);
    },
}
export default Enterprise_settlement_reviewApi;



// WEBPACK FOOTER //
// ./src/api/enterprise_settlement_review.js